type Props = {
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
};

export function FileRowCheckbox({ checked, label, onChange }: Props) {
  return (
    <label
      className="file-row__check"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-label={label}
      />
    </label>
  );
}
